import { useInfiniteQuery } from '@tanstack/react-query';

import { type Form } from '../components/UserManagement/types';
import ExternalApiService, {
  type FormsProps,
} from '../services/ExternalService/ExternalApiService';

interface FormsResponse {
  data: Form[];
  totalItems: number;
  totalPages: number;
}

const fetchInfiniteForms = async (
  formProps: Omit<FormsProps, 'page'>,
  pageParam = 0
): Promise<FormsResponse> => {
  const response = (await ExternalApiService.postForms({
    ...formProps,
    page: pageParam,
  })) as FormsResponse;

  return response;
};

const useInfiniteForms = (
  formProps: Omit<FormsProps, 'page'>,
  options?: { enabled?: boolean }
) =>
  useInfiniteQuery({
    queryKey: ['INFINITE_FORMS', formProps],
    queryFn: ({ pageParam }: { pageParam: number }) =>
      fetchInfiniteForms(formProps, pageParam),
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = allPages.length - 1;

      return currentPage < lastPage.totalPages - 1
        ? currentPage + 1
        : undefined;
    },
    initialPageParam: 0,
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true,
  });

export default useInfiniteForms;
